<template>
  <v-dialog
    v-model="dialog"
  >
    <v-card>
      <v-card-text class="pa-4">
        <apexchart type="line" :height="500" :options="chartOptions" :series="series"></apexchart>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    series: {
      type: Array,
      required: true
    },
    categories: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      dialog: true,
      chartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          text: this.title,
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'],
            opacity: 0.5
          },
        },
        xaxis: {
          categories: this.categories,
        }
      }
    }
  },
  watch: {
    dialog (val) {
      if (!val) {
        setTimeout(() => {
          this.$emit('close')
        }, 300)
      }
    },
  }
}
</script>